import { useState } from 'react';
import { useQuery } from 'react-query';
import { getFolder, getFolders } from '../Views/Assets/ApiAssets';
import Modal from './Modal';
import ChevronLeft from './Svg/ChevronLeft';
import PlusCircle from './Svg/PlusCircle';
import VideoCamera from './Svg/VideoCamera';
import folderIcon from '../assets/img/folder.svg';
import { useTranslation } from 'react-i18next';
import { ASSET_TYPE_VIDEO } from '../constants/assetTypes';

export default function AddYoutube(props) {
  const { setField, edit, fieldName } = props;
  const [isOpen, setIsOpen] = useState(false);
  const { t, i18n } = useTranslation();
  return (
    <>
      <button
        type="button"
        onClick={() => setIsOpen(!isOpen)}
        className={`bg-lightgreen space-x-1 ${
          i18n.language === 'en' ? '' : 'space-x-reverse'
        } text-sm font-bold text-white flex items-center hover:bg-lightgreenhover shadow  px-4 py-2 rounded transition duration-300 ease-in-out`}
      >
        <PlusCircle className="w-5 h-5" />
        <span>{t(edit ? 'Replace Video' : 'Choose Video')}</span>
      </button>

      {isOpen && <ModalContainer setField={setField} isOpen={isOpen} setIsOpen={setIsOpen} fieldName={fieldName} />}
    </>
  );
}

const folderQueryState = {
  typeId: ASSET_TYPE_VIDEO,
  paginationFilter: { pageNumber: 1, pageSize: 10, isPaging: false, langId: 0 },
};

const useAssetFolder = () => {
  const [folderId, setFolderId] = useState(null);
  const folders = useQuery(['assetFolders', folderQueryState], getFolders, {
    staleTime: 1000,
    onSuccess: (data) => setFolderId(data?.data[0]?.id ?? null),
  });
  const folder = useQuery(['assetFolder', folderId], getFolder, {
    staleTime: 1000,
    enabled: !!folderId,
  });
  return { folders, folderId, setFolderId, folder };
};

const buildVideoUrl = (asset) => `${window.env.REACT_APP_IMAGE_PATH}${asset.fileUrl}`;

const ModalContainer = (props) => {
  const { isOpen, setIsOpen, setField, fieldName } = props;
  const { t } = useTranslation();
  const [languageId] = useState(1);
  const [selectedAsset, setSelectedAsset] = useState(null);
  const video = useAssetFolder();
  const rootFolderId = video.folders.data?.data[0]?.id;

  const onSubmit = () => {
    if (!selectedAsset) return;
    const url = buildVideoUrl(selectedAsset);
    if (fieldName) setField(fieldName, url);
    else {
      setField('imageId', selectedAsset.id);
      setField('videoUrl', url);
    }
    setIsOpen(false);
  };

  return (
    <Modal
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      onSubmit={onSubmit}
      title={t('Choose Video')}
      submitType="button"
      add={true}
      className="sm:max-w-3xl"
    >
      {rootFolderId && video.folderId !== rootFolderId && (
        <BackToRootButton onClick={() => video.setFolderId(rootFolderId)} />
      )}
      <div className="flex items-center grid grid-cols-3 lg:grid-cols-3 gap-8 mt-4 mb-8">
        {rootFolderId === video.folderId &&
          video.folders.data?.data?.slice(1).map((f) => (
            <FolderTile key={f.id} name={f.name} itemCount={f.itemCount} onOpen={() => video.setFolderId(f.id)} />
          ))}
        {video.folder.data?.data?.astAssets.map((asset) => (
          <AssetTile
            key={asset.id}
            asset={asset}
            languageId={languageId}
            selected={selectedAsset?.id === asset.id}
            onSelect={() => setSelectedAsset(asset)}
          />
        ))}
      </div>
    </Modal>
  );
};

const BackToRootButton = ({ onClick }) => {
  const { t, i18n } = useTranslation();
  return (
    <div className="flex justify-end">
      <button
        onClick={onClick}
        className={`flex focus:outline-none items-center ${
          i18n.language === 'en' ? '' : 'flex-row-reverse  '
        } justify-start border pr-4  bg-white hover:bg-gray-100 rounded text-gray-800 transition duration-500`}
      >
        <ChevronLeft className="w-5 h-5" /> <span>{t('GO BACK')}</span>
      </button>
    </div>
  );
};

const FolderTile = ({ name, itemCount, onOpen }) => {
  const { t } = useTranslation();
  return (
    <div className="relative bg-white z-5 rounded shadow-md border py-4 px-2">
      <div onClick={onOpen}>
        <div className="text-center">
          <img className="inline-block rounded" alt={folderIcon} src={folderIcon} />
          <b className="block mt-1 mb-2">{name}</b>
          <span className="block text-sm text-gray-400">
            {itemCount} {t('Items')}
          </span>
        </div>
      </div>
    </div>
  );
};

const assetTitle = (asset, languageId) => asset.astAssetLngs.find((l) => l.languageId === languageId)?.title;

const AssetTile = ({ asset, languageId, selected, onSelect }) => (
  <div className="relative bg-white z-0 rounded shadow-md border p-1" style={{ minHeight: 200 }}>
    <input
      className="absolute top-0 z-10 left-0 border m-4 h-4 w-4"
      type="checkbox"
      checked={selected}
      onChange={onSelect}
    />
    <div className="flex items-center justify-center h-20 bg-gray-100 rounded">
      <VideoCamera className="w-10 h-10 text-gray-400" />
    </div>
    <div className="text-center">
      <b className="block mt-1 mb-2">{assetTitle(asset, languageId)}</b>
    </div>
  </div>
);
